import Color from 'color';

type Pc = number; // 1-100

export const alpha = (color: string, percent: Pc) => {
  if (percent >= 100) {
    return color;
  }
  const mixStr = `0.${`0${100 - percent}`.slice(-2)}`;
  const mixNum = parseFloat(mixStr);
  return Color(color).mix(Color('white'), mixNum).hex();
};
